<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
            <div class="content-bottom-padded">
                <el-alert type="info" title="操作说明" show-icon >
                    <div> 说明：第三方权益列表，对接合作的第三方，发送权益给第三方并记录。 </div>
                </el-alert>
            </div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <router-link :to="matchHidePage('editor')">
                        <el-button type="primary" icon="el-icon-plus">新增第三方权益</el-button>
                    </router-link>
                </el-col>

            </el-row>
            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column prop="third_name" label="第三方名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.third_name === 'jh'" class="amount-cur"> 交行 </span>
                    </template>
                </el-table-column>
                <el-table-column prop="type_name" label="权益名称"></el-table-column>
                <el-table-column prop="type" label="权益类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 'shopyhq'" class="amount-cur"> 商城优惠券 </span>
                        <span v-if="scope.row.type === 'distributionyhq'" class="amount-cur"> 多店铺优惠券 </span>
                        <span v-if="scope.row.type === 'points'" class="amount-cur"> 积分 </span>
                        <span v-if="scope.row.type === 'deposit'" class="amount-cur"> 余额 </span>
                    </template>
                </el-table-column>
                <el-table-column prop="type_num" label="每人限量"></el-table-column>
                <el-table-column prop="type_desc" label="描述"></el-table-column>
                <el-table-column prop="type_param" label="额外参数"></el-table-column>

                <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">

                        <!--<i class="mark iconfont icon-trash-alt1" v-if="scope.row.status != 'CARD_STATUS_DISPATCH'" @click="deleteCard(scope.row.shopyhq)"></i>-->
                    </template>
                </el-table-column>

            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>

        </div>
        <router-view></router-view>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex'


    import { getAllThirdsSetting } from '../../../api/third'

    export default {
        data () {
            return {
                editTitleCategroy: '',
                editCategroyVisible:false,
                CategoryList:[],
                office_area_name:[],
                office_area_id:'',
                loadingCategoryF: false,
                submitLoading:false,
                dialogVisible: false,

                current: '', // 当前店铺id
                changeStatus: true,
                activeName: 'first',
                total_count: 0,
                detailDialog: false,
                pcDialogVisible: false,
                dialogTitle: '',
                select_tags_value: '',
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    user_id: '',
                    mobile: ''
                },
                // 实时积分
                realTimeDialog:false,
                realTimeData:'查询中...',
                realTimePointparams:{
                    user_id:'',
                    cardno:''
                },
                form: {
                    distributor_id: null,
                    mobile: '',
                    address: '',
                    name: '',
                    is_valid: 'true',
                    regions_id: [],
                    regions: [],
                    shop_id: 0,
                    contact: ''
                },
                list: [],
                rowdata: {},
                downDistributorVal: false,
                distributor_id: [],
                tag: {
                    dialog: false,
                    editItem: [],
                    list: [],
                    form: {
                        tag_ids: [],
                        distributor_id: []
                    },
                    currentTags: [],
                    tags: []
                },
                chooseCat:[],
                checkAll:false  //全选的v-model值
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            closeDialog () {
                this.dialogVisible = false
                this.pcDialogVisible = false
            },
            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            numberSearch (e) {
                this.params.page = 1
                this.getList()
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            getList () {

                this.loading = true
                getAllThirdsSetting(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count

                    }
                    this.loading = false
                })
            },
            // 实时积分
            getRealTimePoint(user_id,cardno){
                this.realTimePointparams.user_id = user_id
                this.realTimePointparams.cardno = cardno
                getUserCardRealTimePoint(this.realTimePointparams).then(
                    response => {
                        if(response.data.data){
                            this.realTimeData = response.data.data.points
                        }
                    }
                )
                this.realTimeDialog = true
            },
            handleGetRealTimePoint(){
                this.realTimeDialog = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
            },

            deleteCard (id, index) {
                this.$confirm('确定要删除该权益？', '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确定',
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            delThirdsSetting({'card_id':id}).then( res => {
                                this.cardList.splice(index, 1)
                            })
                        }
                        done()
                    }
                })
            },

            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// list.vue?5be2a510